<template>
  <div>
    <header class="banner">
      <div class="container text-center" style="padding: 120px 0 60px 0">
        <h1 class="font-weight-bold text-white display-1">
          {{ constants.appName }}
        </h1>
        <div class="header-content">
          <h2 class="font-weight-bold text-white display-5">
            {{ constants.appDesc }}
          </h2>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
export default {
  data() {
    return {
      constants: this.$constants,
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/cHeader.vue